import trackNewsletter from '../utils/dynamic-yield/dy-track-newsletter';
import trackGender from '../utils/dynamic-yield/dy-track-gender';

export function SubscribeCustomerToNewsletter(form, isDY = false) {
  // AJAX Form submission for the Newsletter subscribe form
  $.ajax({
    type: 'POST',
    async: true,
    url: form.actionURL,
    data: form.$form.serialize(),
    beforeSend: function () {
      form.$container.addClass('sending');
    },
    error: function (data) {
      console.warn('error: ', data);
      form.$container.addClass('error');
      // 429 error - too many requests
      if (data.status == 429) {
        // Allow for default redirect to challenge form, do not force
        form.$form.before(
          `<div class='subscribe-form__content-copy-errors'>Too many requests: ${data.statusText}(${data.status})</div>`
        );
      } else {
        e.preventDefault();
        // if fields are empty, paste errors
        form.$form.before(
          `<div class='subscribe-form__content-copy-errors'>${data.response.statusText}</div>`
        );
      }
    },
    success: function (data, textStatus, jqXHR) {
      if (jqXHR.status == 302) {
        console.error(`Error - Status: ${jqXHR.status}`, `jqXHR:`, jqXHR);
        window.location.href = jqXHR.location;
        return false;
      }

      if (jqXHR.status !== 200) {
        console.error(`Error - Status: ${jqXHR.status}`, `jqXHR:`, jqXHR);
        form.$form.before(
          `<div class='subscribe-form__content-copy-errors'>Unsuccessful:${data.textStatus}</div>`
        );
        return false;
      }

      /*
      * Check if the submission was indeed successful, because sometimes the challenge returns..
      We need to style the DY Popup Form as well as the Original Shopify Popup Form
      */
      form.$container.addClass('success');
      form.$formHeading.fadeOut(300);
      form.$formSubHeading.fadeOut(300);
      form.$form.fadeOut(300, function () {
        $(this).closest(form.parentClass).append(form.successMsg);
      });

      /* Fire the DY Event - Event Tracking */
      if (isDY) {
        const formattedGenderValue = form.$genderDropdown.val().split(',')[0];
        trackNewsletter(form.$emailInput.val());
        if (formattedGenderValue) {
          trackGender(formattedGenderValue);
        }
      }
    },
  });
}
